import React, { useCallback, useState } from 'react';
import { Link as RRLink } from 'react-router-dom';
import { appendClassProps } from '../util';
/**
 - Use a link to either route to a url, or as a generic clickable text component
 */
export const Link = ({ newTab = false, url, href, state, onClick, className, children }) => {
    const [depressed, setDepressed] = useState(false);
    const onMouseDown = useCallback(() => {
        setDepressed(true);
    }, []);
    const onMouseUp = useCallback(() => {
        setDepressed(false);
    }, []);
    return url ? (React.createElement(RRLink, { "data-testid": "link", className: `font-normal cursor-pointer text-blue-500${appendClassProps(className)}${depressed ? ' text-blue-600' : ' hover:text-blue-400'}`, to: url, onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, target: newTab ? 'blank' : undefined, rel: newTab ? 'noopener noreferrer' : undefined, state: state }, children)) : (React.createElement("a", { "data-testid": "link", className: `font-normal cursor-pointer text-blue-500${appendClassProps(className)}${depressed ? ' text-blue-600' : ' hover:text-blue-400'}`, href: href, onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, target: newTab ? 'blank' : undefined, rel: newTab ? 'noopener noreferrer' : undefined }, children));
};
export * from './index.types';
//# sourceMappingURL=index.js.map